import obtenerHistorialPorConcesion from "./obtenerPorConcesion";
import agruparArray from "../../historial/agruparArray";

/**
 * Actualiza el historial de ordenes de pago después de generar una nueva póliza
 * @param {Number} idConcesion 
 * @param {Object} data 
 * @param {Function} setData 
 */
export default async function actualizarHistorial(data, setData) {
    const idConcesion = data.concesionActual.idConcesion;
    const dataHistorial = await obtenerHistorialPorConcesion(idConcesion);
    setData({ ...data, historial: [...dataHistorial], historialArray: [...agruparArray(dataHistorial, 10)] });
}